import { selexpConParApiDuck } from '../selexp-conpar-api-duck';
import { TFeatureFlags } from './types-feature-flags';

export const featureFlagsApiDuck = selexpConParApiDuck.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureFlags: builder.query<TFeatureFlags, string>({
      query: () => ({
        url: '/AppConfiguration/GetFeatureFlags',
        noFilters: true,
        headers: {
          'Cache-Control': 'no-cache no-store',
        },
      }),
    }),
  }),
});

export const { useGetFeatureFlagsQuery } = featureFlagsApiDuck;
